import * as _ from 'underscore';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { AccelerationTasks } from '../resources/AccelerationTasks';
import { ExtractTasks } from '../resources/ExtractTasks';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { Subscriptions } from '../resources/Subscriptions';
import { ServerService } from '../services/ServerService';
import { ContentFilterKeyName, ContentFiltersKeys, IContentFilters } from './ContentFilters';
import { DataAlertContentType, ExtractTaskContentType, RunFlowTaskContentType, SubscriptionContentType, AccelerationTaskContentType } from './ContentTypes';
import { IPlace, Place, Subplace } from './IPlace';

// TODO: This should be named "TasksPlace".
export class TaskPlace {

  private static ExcludeFilterKeys: ContentFilterKeyName[] = [
    ContentFiltersKeys.siteId
  ];

  public static $inject = [
    '$location',
    'DataAlerts',
    'ExtractTasks',
    'RunFlowTasks',
    'ServerService',
    'Subscriptions',
    'AccelerationTasks'
  ];

  constructor(
    private $location: ng.ILocationService,
    private DataAlerts: DataAlerts,
    private ExtractTasks: ExtractTasks,
    private RunFlowTasks: RunFlowTasks,
    private serverService: ServerService,
    private Subscriptions: Subscriptions,
    private AccelerationTasks: AccelerationTasks,
  ) {

  }

  public create(siteId?: string, implicitFilters: Partial<IContentFilters<string>> = {}): IPlace {
    const place = new Place('task');
    const excludeFilterKeys: ContentFilterKeyName[] =
        _.union(TaskPlace.ExcludeFilterKeys, _.keys(implicitFilters) as ContentFilterKeyName[]);

    place.addSubplace(Subplace.create(
      'extractTasks',
      ExtractTaskContentType,
      this.ExtractTasks,
      _.extend({}, implicitFilters, { siteId: siteId }),
      excludeFilterKeys));

    place.addSubplace(Subplace.create(
      'subscriptions',
      SubscriptionContentType,
      this.Subscriptions,
      _.extend({}, implicitFilters, { siteId: siteId }),
      excludeFilterKeys));

    if (siteId && this.serverService.isDataAlertsEnabled()) {
      place.addSubplace(Subplace.create(
        'dataAlerts',
        DataAlertContentType,
        this.DataAlerts,
        _.extend({}, implicitFilters, { siteId: siteId }),
        excludeFilterKeys));
    }

    if (
      !siteId && this.serverService.flowsOnServerEnabled() ||
       siteId && this.serverService.flowsOnSiteEnabled()
    ) {
      place.addSubplace(Subplace.create(
        'runFlowTasks',
        RunFlowTaskContentType,
        this.RunFlowTasks,
        _.extend({}, implicitFilters, { siteId: siteId }),
        excludeFilterKeys
      ));
    }

    place.addSubplace(Subplace.create(
      'accelerationTasks',
      AccelerationTaskContentType,
      this.AccelerationTasks,
      _.extend({}, implicitFilters, { siteId: siteId }),
      excludeFilterKeys));

    return place;
  }

}

Module.instance().service('TaskPlace', TaskPlace);
